export const sheetsAddonUseCasesData = [{
   role: "Accountants and Bookkeepers",
   usecases:
            <>
               <ul>
                  <li><p style={{display: 'inline'}}>Convert PDF bank statements to Google Sheets, with a CSV download for importing into accounting software</p></li> 
                  <li>Enter invoice, bill tables into Google Sheets in 1 click without manual entry.</li>
               </ul> 
               <div style={{textAlign: 'left', marginLeft: '10px', fontSize: '15px'}}><a href="https://youtu.be/8QFhjPZhh88?si=fk5sKrYLknIl0il0" style={{color: '#880808'}} target="_blank">Watch our video showing the process</a></div>
            </>
}, {
    role: "Data Analysts",
    usecases:
             <ul>
                <li>Convert data-heavy reports, scientific tables directly inside Google Sheets in 1 click</li>
                <li>Save more time for analysis and modeling</li>
             </ul> 
}, {
    role: "Small Business Owners",
    usecases:
             <ul>
                <li>Manage bills without staff</li>
                <li>Convert financial or inventory reports quickly</li>
             </ul> 
},{
    role: "Procurement and Logistics Teams",
    usecases:
             <>
               <ul>
                  <li>Extract data from purchase orders, invoices, and shipping documents in 1 click</li>
                  <li>Manage inventory or customer records 5-10 times faster and easier</li>
               </ul>
             </> 
}, {
   role: "Administrative Professionals",
   usecases:
            <>
               <ul>
                  <li>Digitize invoices, application forms, and reports directly inside Google Sheets in 1 click</li>
               </ul> 
               <div style={{textAlign: 'left', marginLeft: '10px', fontSize: '15px'}}><a href="https://youtu.be/R9TnFLLxM9E?si=cVT7SNXnxvfmpruf" style={{color: '#880808'}} target="_blank">Watch our video showing how to extract invoice data from image</a></div>
            </>
}, {
    role: "Auditors",
    usecases:
             <ul>
                <li>Extract tables from reports in 1 click and save more time for main tasks.</li>
             </ul> 
}, {
   role: "Researchers and Students",
   usecases:
            <ul>
               <li>Turn data within academic PDFs into editable data sets without any typing.</li>
            </ul> 
}, {
    role: "Property Managers",
    usecases:
             <ul>
                <li>Process leases, rental agreements, and inspection forms 5-10 times faster.</li>
             </ul> 
}, {
   role: "Finance Analysts",
   usecases:
            <>
               <ul>
                  <li>Analyze tabular data from PDFs quickly without wasting time on data entry</li>
               </ul> 
               <div style={{textAlign: 'left', marginLeft: '10px', fontSize: '15px'}}><a href="https://youtu.be/pkThOZ0drVA?si=SPGwRGhaC0Xs_W2z" style={{color: '#880808'}} target="_blank">Watch our video showing how to copy table without manual entry</a></div>
            </>
}]